import { PublicLayout } from "../components/layout/PublicLayout";

export default function Privacy() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6">
        <div className="mb-8 border-b border-slate-200 pb-6">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="personaw logo" className="h-10 w-10 object-contain rounded-lg shadow-sm" />
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Privacy Policy</h1>
              <p className="mt-1 text-xs font-medium text-slate-500">Last updated: September 25, 2025</p>
            </div>
          </div>
        </div>

        <div className="space-y-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <section className="space-y-2">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">1. Information We Collect</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              personaw ("Service") collects your name, email address, and profile picture through Google OAuth. We also store career information, skills, and work style preferences that you voluntarily provide.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">2. Purpose of Collection</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              Collected data is used to power core features including AI persona generation, resume creation, team-fit matching, and AI chat interviews. We do not use your data for marketing purposes.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">3. Data Retention</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              All personal data is deleted immediately upon account deletion. However, data may be retained as required by applicable laws for the designated retention period.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">4. Third-Party Sharing</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              We do not share your personal data with third parties without your consent. AI processing uses the Anthropic API, and payment processing uses Paddle. Each service operates under its own privacy policy.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">5. Your Rights</h2>
            <p className="text-sm leading-relaxed text-slate-700 sm:text-base">
              You can review your data or delete your account at any time from the Settings page. For inquiries, please contact us at the email below.
            </p>
          </section>

          <section className="space-y-2 border-t border-slate-100 pt-6">
            <h2 className="text-base font-semibold text-slate-900 sm:text-lg">6. Contact</h2>
            <p className="text-sm text-slate-700 sm:text-base">
              Privacy inquiries:{" "}
              <a href="mailto:privacy@personaw.com" className="font-semibold text-teal hover:underline">
                privacy@personaw.com
              </a>
            </p>
          </section>
        </div>

        <div className="mt-8 flex justify-start">
          <a
            href="/"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 transition hover:text-navy"
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </PublicLayout>
  );
}
